import styled from "styled-components";

interface IToolBarButtonProps {
  isActive?: boolean;
}
export const ToolBarButton = styled.button<IToolBarButtonProps>`
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.lexicalEditor.borderColor : "transparent"};
  border: none;

  border-radius: 4px;

  padding: 0.5rem;

  display: flex;
  align-items: center;
  gap: 0.75rem;

  color: ${({ theme }) => theme.lexicalEditor.fontPrimaryColor};
  text-overflow: ellipsis;
  line-height: 1.25rem;
  overflow: hidden;

  transition: all 0.2s ease-in-out;

  font: 400 0.875rem/1rem "Inter";

  svg,
  .loader {
    height: 1rem;
    width: 1rem;
    background-size: contain;
  }

  :hover {
    background-color: ${({ theme }) => theme.lexicalEditor.borderColor};
  }

  :disabled {
    cursor: not-allowed;
  }

  :not(:disabled) {
    cursor: pointer;
  }
`;

interface IToolbarInsertImageButtonProps {
  isActive?: boolean;
}
export const ToolbarInsertImageButton = styled.label<IToolbarInsertImageButtonProps>`
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.lexicalEditor.borderColor : "transparent"};
  border: none;

  border-radius: 4px;

  padding: 0.5rem;

  display: flex;
  align-items: center;
  gap: 0.75rem;

  color: ${({ theme }) => theme.lexicalEditor.fontPrimaryColor};
  text-overflow: ellipsis;
  line-height: 1.25rem;
  overflow: hidden;

  transition: all 0.2s ease-in-out;

  font: 400 0.875rem/1rem "Inter";

  input {
    display: none !important;
  }

  svg,
  .loader {
    height: 1rem;
    width: 1rem;
    background-size: contain;
  }

  :hover {
    background-color: ${({ theme }) => theme.lexicalEditor.borderColor};
  }

  :disabled {
    cursor: not-allowed;
  }

  :not(:disabled) {
    cursor: pointer;
  }
`;
